import ToolGridArea, { ToolGridAreaType } from "./ToolGridArea";
import CommonSubtitle from "@/components/common/CommonSubtitle";

export type THeroSectionInfoType = {
  heroSection?: {
    heroTitle?: string;
    heroSubtitle?: string;
  };
  featuredArea: ToolGridAreaType[];
};

const ToolFeaturedArea = ({
  heroSectionInfo,
}: {
  heroSectionInfo: THeroSectionInfoType;
}) => {
  return (
    <section
      className={`container px-4 ${heroSectionInfo?.heroSection?.heroTitle ? "xl:pt-22 pt-16 md:pt-24" : "pt-8 xl:pt-12"}`}
    >
      {heroSectionInfo?.heroSection?.heroTitle && (
        <div className="mx-auto max-w-[1100px] space-y-4 pb-14 text-center xl:space-y-8 xl:px-20 xl:pb-20">
          <h2 className="text-[24px] font-semibold text-[#202020] lg:text-[32px]">
            {heroSectionInfo.heroSection.heroTitle}
          </h2>
          <CommonSubtitle
          >
            {heroSectionInfo.heroSection.heroSubtitle}
          </CommonSubtitle>
        </div>
      )}
      <ToolGridArea gridAreaInfo={heroSectionInfo.featuredArea} />
    </section>
  );
};

export default ToolFeaturedArea;
